import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './toast.css';

export default function Toast() {
  const [toasts, setToasts] = useState([]);
  const location = useLocation();

  useEffect(() => {
    // expose a global helper for quick use
    // showToast signature: (message, type = 'info', timeout = 3500, position = 'top-right')
    // position can be: 'top-right' (default) or 'center'
    window.showToast = (message, type = 'info', timeout = 3500, position = 'top-right') => {
      const id = Date.now() + Math.random();
      setToasts(t => [...t, { id, message, type, position }]);
      setTimeout(() => {
        setToasts(t => t.filter(x => x.id !== id));
      }, timeout);
    };
    return () => { try { delete window.showToast; } catch (e) { } };
  }, []);

  // If we're on the Home page (path exactly '/'), show toasts at top-right
  const isHome = location && (location.pathname === '/' || location.pathname === '');

  // split toasts by position so we can render center-toasts separately
  const topToasts = toasts.filter(t => !t.position || t.position === 'top-right');
  const centerToasts = toasts.filter(t => t.position === 'center');

  return (
    <>
      <div className={`toast-root ${isHome ? 'top' : ''}`} aria-live="polite">
        {topToasts.map(t => (
          <div key={t.id} className={`toast ${t.type || 'info'}`}>
            <div className="toast-message">{t.message}</div>
          </div>
        ))}
      </div>

      {/* centered toasts (modal-like) */}
      {centerToasts.length > 0 && (
        <div className="toast-center-root" aria-live="polite">
          {centerToasts.map(t => (
            <div key={t.id} className={`toast ${t.type || 'info'} centered`}>
              <div className="toast-message">{t.message}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
